<div class="container">
    <div class="col-md-5 mx-auto form-box">
        <form [formGroup]="changeMemorableForm" (ngSubmit)="changeMemorable()">
            <div class="box-title">
                <strong>Change Memorable Number </strong>
            </div>

            <div class="form-group">
                <mat-form-field [ngClass]="{'is-invalid': !changeMemorableForm.get('oldMemorable').valid && changeMemorableForm.get('oldMemorable').touched,
                    'is-valid': changeMemorableForm.get('oldMemorable').valid && changeMemorableForm.get('oldMemorable').touched} ">
                    <input matInput formControlName="oldMemorable" type="password" npDetectFocus #ipOP="detectFocus" placeholder="Old Memorable Number">
                </mat-form-field>
                <div *ngIf="!changeMemorableForm.get('oldMemorable').valid && changeMemorableForm.get('oldMemorable').touched && !ipOP.isFocus">
                    <p class="error-message">Please input information here</p>
                </div>
            </div>

            <div class="form-group">
                <mat-form-field [ngClass]="{
                        'is-invalid': ((!changeMemorableForm.get('newMemorable').valid || wrongPin) && changeMemorableForm.get('newMemorable').touched && !ipNP.isFocus) || (changeMemorableForm.hasError('memorablenotmatch') && changeMemorableForm.get('confirmNewMemorable').touched && changeMemorableForm.get('newMemorable').valid && !ipCNP.isFocus && !ipNP.isFocus),
                        'is-valid': changeMemorableForm.get('newMemorable').valid && !wrongPin && !changeMemorableForm.hasError('memorablenotmatch') && !ipCNP.isFocus && !ipNP.isFocus
                      }">
                    <input matInput placeholder="New Memorable Number" formControlName="newMemorable" type="password" npDetectFocus #ipNP="detectFocus"
                        maxlength="6" (keypress)="(($event.charCode >= 48 && $event.charCode <= 57) || $event.charCode === 0)"
                    />
                </mat-form-field>
                <div *ngIf="changeMemorableForm.get('newMemorable').hasError('required') && changeMemorableForm.get('newMemorable').touched && !ipNP.isFocus">
                    <p class="error-message">Please enter valid information here</p>
                </div>
                <div class="error-message" *ngIf="(wrongPin || changeMemorableForm.get('newMemorable').hasError('minlength') || changeMemorableForm.get('newMemorable').hasError('maxlength')) && !ipNP.isFocus">
                    Memorable Number has 6 numeric characters and no repetition or sequencing.
                </div>
            </div>

            <div class="form-group">
                <mat-form-field [ngClass]="{
                        'is-invalid': changeMemorableForm.hasError('memorablenotmatch') && changeMemorableForm.get('confirmNewMemorable').touched && changeMemorableForm.get('newMemorable').valid && !wrongPin && !ipCNP.isFocus && !ipNP.isFocus,
                        'is-valid': !changeMemorableForm.hasError('memorablenotmatch') && changeMemorableForm.get('newMemorable').valid && !wrongPin && !ipCNP.isFocus && !ipNP.isFocus
                      }">
                    <input matInput placeholder="Confirm New Memorable Number" formControlName="confirmNewMemorable" type="password" npDetectFocus
                        #ipCNP="detectFocus" maxlength="6" (keypress)="(($event.charCode >= 48 && $event.charCode <= 57) || $event.charCode === 0)"
                    />
                </mat-form-field>
                <div class="error-message" *ngIf="!changeMemorableForm.get('confirmNewMemorable').touched && changeMemorableForm.get('confirmNewMemorable').touched && changeMemorableForm.get('newMemorable').valid && !wrongPin && !ipCNP.isFocus && !ipNP.isFocus">
                    Please confirm your new Memorable number
                </div>
                <div class="error-message" *ngIf="changeMemorableForm.get('confirmNewMemorable').touched && changeMemorableForm.hasError('memorablenotmatch') && changeMemorableForm.get('newMemorable').valid && !wrongPin && !ipCNP.isFocus && !ipNP.isFocus">
                    Memorable number and Confirm Memorable number do not match
                </div>
            </div>
            <div class="form-group pt-2">
                <button class="btn btn-block btn-lg" [ngClass]="{
                'btn-inactive': !changeMemorableForm.valid || wrongPin,
                'btn-greengo': changeMemorableForm.valid && !wrongPin
              }" type="submit" npFocusOutClicked>Save</button>
            </div>
        </form>
    </div>
</div>